export default "__VITE_ASSET__BRVI2DDG__"